import React from 'react';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { store } from 'src/store/index';

export type State = {
  keys?: number[];
  type?: 'success' | 'info' | 'warning' | 'error';
  message?: React.ReactNode;
  activeKey?: number;
  isOff?: boolean;
};

const initialState: State = {
  keys: [],
  activeKey: 0,
};

const { reducer, actions } = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    on(state, action: PayloadAction<State>) {
      const newKey = (state.activeKey || 0) + 1;

      state.activeKey = newKey;
      state.keys && state.keys.push(newKey);
      state.type = action.payload.type;
      state.message = action.payload.message;
      state.isOff = false;
    },
    off(state) {
      state.type = undefined;
      state.message = undefined;
      state.isOff = true;
    },
  },
});

const notify = {
  on(arg: State) {
    store.dispatch(actions.off());

    setTimeout(() => {
      store.dispatch(actions.on(arg));
    }, 100);
  },
  off() {
    store.dispatch(actions.off());
  },
};

export { reducer, notify };
export default actions;
